import React from 'react';
import DayPicker from 'react-day-picker';

import 'react-day-picker/lib/style.css';

// Removed lazy loading due to an issue that needs to be investigated
// https://www.americandream.com/birthdays-the-gameroom
export default function LazyDayPicker({ ...props }) {
  return <DayPicker {...props} />;
}
